// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n94s","tabsBox":"styles_tabsBox__2F5am","createButton":"styles_createButton__eb1vX"};